import React from 'react'
import {Link} from 'react-router-dom'

const Footer = () => {
    return (
        <footer className='footer pt-10 pb-16'>
            <div className="container mx-auto">
                <div className="flex lg:flex-row flex-col justify-end items-start lg:items-center gap-5">
                    <Link to={"/faqs"} className='font-semibold'>
                        FAQs
                    </Link>
                    <Link to={"/contact"} className='font-semibold'>
                        Contact
                    </Link>
                    <Link to={"/privacy-policy"} className='font-semibold'>
                        Privacy Policy
                    </Link>
                </div>
            </div>

            <hr className='my-10'/>
            <div className="container mx-auto">
                <h2 className='font-bold text-[30px]'>Want to try it out?</h2>
                <p className='text-lg mt-3 mb-8'>
                    Send us an email and our team will send you a starter kit to try our technology
                </p>

                <Link to={"/contact"}
                      className='bg-black text-white uppercase px-8 py-3 rounded-[4px] font-semibold'>
                    Learn More
                </Link>
            </div>
        </footer>
    )
}

export default Footer
